import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=73339815&scoped=true&lang=pug"
import script from "./AppProfile.vue?vue&type=script&lang=ts"
export * from "./AppProfile.vue?vue&type=script&lang=ts"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=73339815&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73339815",
  null
  
)

export default component.exports